import { IconMailbox, IconUsers } from '@tabler/icons-react';
import { Route } from '../types/routes.type';

export const mainNavigation: Route[] = [
	{ label: 'Entries', icon: IconUsers, link: '/entries' },
	{ label: 'Campaigns', icon: IconMailbox, link: '/campaigns' },
];
